import { TermInterestRateOverride } from "./TermInterestRateOverride";
export class TermInterestRateOverrides {
    _overrides = [];
    constructor(overrides = []) {
        this.overrides = overrides;
        this.updateJsValues();
    }
    updateModelValues() {
        this._overrides.forEach((bm) => bm.updateModelValues());
    }
    updateJsValues() {
        this._overrides.forEach((bm) => bm.updateJsValues());
    }
    get overrides() {
        return this._overrides || [];
    }
    set overrides(value) {
        // check type and inflate if necessary
        this._overrides = value
            .map((c) => {
            if (c instanceof TermInterestRateOverride) {
                return c;
            }
            return new TermInterestRateOverride(c);
        })
            .sort((a, b) => a.termNumber - b.termNumber);
    }
    get all() {
        return this._overrides;
    }
    get active() {
        return this._overrides.filter((o) => o.active);
    }
    /* ── bulk toggles (UI header switch uses these) ─────────────── */
    deactivateAll() {
        this._overrides.forEach((o) => (o.active = false));
    }
    activateAll() {
        this._overrides.forEach((o) => (o.active = true));
    }
    addOverride(override) {
        // check if override is of correct type oterhwise inflate
        if (!(override instanceof TermInterestRateOverride)) {
            override = new TermInterestRateOverride(override);
        }
        this._overrides.push(override);
        this.reSort();
    }
    removeOverrideAtIndex(index) {
        this._overrides.splice(index, 1);
        this.reSort();
    }
    get length() {
        return this._overrides.length;
    }
    atIndex(index) {
        return this._overrides[index];
    }
    get first() {
        return this._overrides[0];
    }
    get last() {
        return this._overrides[this._overrides.length - 1];
    }
    get json() {
        return this._overrides.map((override) => override.json);
    }
    toJSON() {
        return this.json;
    }
    isDuplicateTermNumber(termNumber) {
        return this._overrides.filter((override) => override.termNumber === termNumber).length > 1;
    }
    reSort() {
        this._overrides = this._overrides.sort((a, b) => a.termNumber - b.termNumber);
    }
}
